import React from "react";
import { Col, Row } from "reactstrap";
import FeatherIcons from "feather-icons-react";
import { Link } from "react-router-dom";

const StoreFooter = () => {
  return (
    <Row className="mt-5">
      <Col xs={6} sm={3} md={3} lg={1}>
        <p>&copy; Devout</p>
      </Col>
      <Col xs={6} sm={3} md={3} lg={1}>
        <Link to="/template" className="text-upper">
          Newsletter
        </Link>
      </Col>
      <Col xs={6} sm={3} md={3} lg={1}>
        <Link to="/template" className="text-upper">
          Returns
        </Link>
      </Col>
      <Col xs={6} sm={3} md={3} lg={2}>
        <Link to="/template" className="text-upper">
          Sneaker news
        </Link>
      </Col>
      <Col xs={6} sm={3} md={3} lg={1}>
        <Link to="/template" className="text-upper">
          FAQ
        </Link>
      </Col>
      <Col xs={6} sm={3} md={3} lg={2}>
        <Link to="/template" className="text-upper">
          Privacy Policy
        </Link>
      </Col>
      <Col xs={6} sm={3} md={3} lg={{ size: 1, offset: 2 }}>
        <a href="https://github.com/BenjaminBenitez-cmd/devout">
          <FeatherIcons icon="github" />
        </a>
      </Col>
    </Row>
  );
};

export default StoreFooter;
